import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography, createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(() =>
    createStyles({
        default: {
            'border': 0,
            'padding': 0,
            'fontSize': 14,
            'fontWeight': 500,
            'width': '100%',
            'color': '#000',
            'display': 'flex',
            'alignItems': 'center',
            'backgroundColor': '#fff',

            '& p': {
                fontSize: 14,
                fontWeight: 500
            }
        },
        parent: {
            'padding': '16px 0px',

            '&:not(:last-child):not(div)': {
                borderBottom: 'solid 1px #D4D4D4'
            },

            '& > svg': {
                fontSize: 18,
                marginRight: 13,
                marginBottom: -2
            }
        },
        parentWithChilds: {
            paddingBottom: 8
        },
        childContainer: {
            paddingBottom: 8,
            borderBottom: 'solid 1px #D4D4D4'
        },
        child: {
            padding: '6px 0px 6px 32px'
        },
        label: {
            marginRight: 'auto',
            color: (props: ActionButtonType) => (props.color ? props.color : undefined)
        }
    })
);

export interface ActionButtonType {
    icon?: IconProp;
    label: string | React.ReactNode;
    color?: string;
    items?: Array<ActionButtonItem>;
    leftElement?: React.ReactNode;
    rightElement?: React.ReactNode;
    onClick: () => void;
}

export interface ActionButtonItem {
    label: string | React.ReactNode;
    onClick: () => void;
}

export const ActionButton: React.FunctionComponent<ActionButtonType> = props => {
    const classes = useStyles(props);

    const content = (
        <>
            {props.icon && (
                <FontAwesomeIcon
                    icon={props.icon}
                    color={props.color || '#000'}
                />
            )}

            {props.leftElement && props.leftElement}

            <Typography className={classes.label}>{props.label}</Typography>

            {props.rightElement && props.rightElement}
        </>
    );

    return (
        <>
            {props.items ? (
                <>
                    <div className={clsx(classes.default, classes.parent, classes.parentWithChilds)}>{content}</div>
                    <div className={classes.childContainer}>
                        {props.items.map((item, index) => (
                            <button
                                key={index}
                                className={clsx(classes.default, classes.child)}
                                onClick={event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    item.onClick();
                                }}
                            >
                                <Typography>{item.label}</Typography>
                            </button>
                        ))}
                    </div>
                </>
            ) : (
                <button
                    type="button"
                    className={clsx(classes.default, classes.parent)}
                    onClick={event => {
                        event.preventDefault();
                        event.stopPropagation();
                        props.onClick();
                    }}
                >
                    {content}
                </button>
            )}
        </>
    );
};
